import CardFA from './CardFA';
export default CardFA;
